import LoginForm from "~/components/login-form/login-form";

export default function Login() {
  return (
    <LoginForm />
  )
}
